import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Services() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  const services = [
    {
      icon: 'ri-instagram-line',
      title: 'Social Media Management',
      description: 'Full-service management of your social channels including content creation, community engagement, and growth strategies.',
      gradient: 'from-[#00989e] to-[#00b4a6]',
      link: '/services/social-media-management'
    },
    {
      icon: 'ri-video-line',
      title: 'Video & Reels Production',
      description: 'Scroll-stopping short-form video content optimized for TikTok, Instagram Reels, and YouTube Shorts.',
      gradient: 'from-[#00b4a6] to-[#00c4b0]',
      link: '/services/video-production'
    },
    {
      icon: 'ri-palette-line',
      title: 'Branding',
      description: 'Comprehensive brand identity development including logo design, brand guidelines, visual identity, and brand messaging.',
      gradient: 'from-[#00c4b0] to-[#007a7f]',
      link: '/services/branding'
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Paid Social Advertising',
      description: 'High-converting ad campaigns across Meta, TikTok, LinkedIn, and Pinterest with precise targeting.',
      gradient: 'from-[#007a7f] to-[#006b6f]',
      link: '/services/paid-advertising'
    },
    {
      icon: 'ri-quill-pen-line',
      title: 'Content Strategy',
      description: 'Data-driven content calendars and creative direction that align with your brand voice and business goals.',
      gradient: 'from-[#006b6f] to-[#00989e]',
      link: '/services/content-strategy'
    },
    {
      icon: 'ri-layout-line',
      title: 'Website Design',
      description: 'Beautiful, conversion-focused websites with responsive design, UX/UI optimization, and SEO foundation.',
      gradient: 'from-[#00989e] to-[#00b4a6]',
      link: '/services/web-design'
    }
  ];

  return (
    <section
      ref={ref}
      className={`py-20 bg-white transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <h2 className="text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to dominate social media and grow your brand online
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              to={service.link}
              key={index}
              className={`bg-white rounded-xl p-8 border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer block ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${index * 80}ms` : '0ms', transitionDuration: '500ms' }}
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>
              <span className="inline-flex items-center text-[#00989e] font-semibold hover:gap-2 transition-all">
                Learn More
                <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
